import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@domainstack/ui/skeleton";
import { cn } from "@domainstack/ui/utils";
type AccentColor = "blue" | "cyan" | "green" | "orange" | "purple" | "indigo" | "slate";
function colorToClasses(color: AccentColor) {
  return color === "blue" ? "text-accent-blue bg-accent-blue/18" : color === "cyan" ? "text-accent-cyan bg-accent-cyan/18" : color === "green" ? "text-accent-green bg-accent-green/18" : color === "orange" ? "text-accent-orange bg-accent-orange/18" : color === "purple" ? "text-accent-purple bg-accent-purple/18" : color === "indigo" ? "text-accent-indigo bg-accent-indigo/18" : "text-accent-slate bg-accent-slate/18";
}
export function PillCount(t0) {
  const $ = _c(6);
  const {
    count,
    color: t1,
    className
  } = t0;
  const color = t1 === undefined ? "slate" : t1;
  let t2;
  if ($[0] !== className || $[1] !== color) {
    t2 = cn("inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 font-mono text-[10px] font-semibold", colorToClasses(color), className);
    $[0] = className;
    $[1] = color;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== count || $[4] !== t2) {
    t3 = <span className={t2}>{count}</span>;
    $[3] = count;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export function PillCountSkeleton(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("h-5 w-6 rounded-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Skeleton className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}